import moment from "moment";
import React from "react";
import ZeroScreen from "../zero-screen";
import { ACCOUNT_SUMMARY } from "../../../../data/constants";

export function renderBillDetails(
  billsDetails: any,
  setInvoiceSummary: any,
  fetchInvoiceDetails: any
) {
  return !!billsDetails?.length
    ? billsDetails.map((billsDetail: any, i: number) => {
        return (
          <div
            key={i}
            onClick={() => {
              setInvoiceSummary(true);
              fetchInvoiceDetails(billsDetail.saleId);
            }}
          >
            <div
              className={
                "flex sm:flex-col justify-between items-center text-14 border-b border-[#EBEBEB] p-16 smd:p-12 cursor-pointer"
              }
            >
              <div className="flex justify-between basis-3/4 smd:basis-2/3 sm:w-full ">
              <div className="pl-5 flex flex-col ">
                <div className="border-none bg-[#0000000D] py-4 px-8 border font-semibold inline-flex rounded-[6px] w-fit mb-8">
                  #{billsDetail?.billNumber}
                </div>
                <div className="opacity-50 text-[12px] sm:mb-8 whitespace-nowrap">
                  Pending Since {moment(billsDetail.time).format("D MMM")}
                </div>
              </div>
              <div className="flex smd:flex-col !items-center smd:!items-end !justify-between smd:justify-center basis-2/3">
                {" "}
                <div className=" flex smd:text-[13px] px-20 smd:px-0">
                  <div className="opacity-50 mr-2">Bill Total: </div>
                  <div className=""> ₹{Number(billsDetail.saleAmount).toFixed(2)}</div>
                </div>
                <div className=" flex smd:text-[13px] px-20 smd:px-0">
                  <div className="opacity-50 mr-2">Collected: </div>
                  <div className="">
                    {" "}
                    ₹{Number(billsDetail.saleAmount - billsDetail.balanceAmount).toFixed(2)}
                  </div>
                </div>
              </div>
              </div>
              <div className=" flex flex-col sm:flex-row sm:w-full sm:justify-center bg-[#A558581A] rounded-[8px] text-[12px] p-8">
                <div className="text-[#A55858] sm:pr-4 font-semibold">
                  {Math.trunc(
                    (billsDetail.balanceAmount / billsDetail.saleAmount) * 10000
                  ) / 100}
                  % Pending
                </div>
              </div>
            </div>
          </div>
        );
      })
    : <ZeroScreen showSummaryDetails={true} summaryType={ACCOUNT_SUMMARY.credit.id}/>;
}
